import { Environment } from "./environment.interface";

/** AWS development environment configuration */
export const environment: Environment = {
  production: false,
  apiUrl: "https://k9xdduc4a0.execute-api.eu-north-1.amazonaws.com", // AWS API Gateway DEV
  cognito: {
    userPoolId: "eu-north-1_l2JlRckKZ",
    userPoolClientId: "376pj88rsgj9d0gn23qa5dq9k6",
    region: "eu-north-1",
  },
  intercomAppId: "px632msh", // Intercom DEV workspace
  intercomBrandId: "21131", // Nquadro DEV brand
  mixpanel: {
    token: "329d1beec08451a64974425e43496d61",
    apiHost: "https://api-eu.mixpanel.com", // EU Data Residency
    enabled: true, // Enabled in DEV environment
    environment: "dev",
  },
};
